<ion-card class="pending-card card-1">
    <!-- [ngClass]="{ 'application-grid-expanded': (canBook$ | async), 'application-grid': !(canBook$ | async) }" -->
    <ion-grid fixed class="application-grid">
        <ion-row>
            <ion-col class="slider-col" size="4" size-xs="0" size-sm="0" size-md="0" size-lg="0" size-xl="4">
                <ion-slides [options]="sliderOpts" *ngIf="status?.application?.program?.image.length > 0" pager="true">
                    <ion-slide *ngFor="let image of images; let i = index" (click)="openPreview(image, i)">
                        <img class="program-image" [src]="image | img : status?.application?.program?.state : 'md'" />
                    </ion-slide>
                </ion-slides>

                <ion-slides [options]="sliderOpts" *ngIf="status?.application?.program?.image.length === 0">
                    <ion-slide>
                        <img class="program-image" [src]="status?.application?.program?.image | img : status?.application?.program?.state : 'md'" />
                    </ion-slide>
                </ion-slides>
            </ion-col>
            <ion-col size="12" size-xs="12" size-sm="12" size-md="12" size-lg="12" size-xl="6" color="light-teal">
                <div class="more-actions-container">
                    <ion-button class="more-actions-button" fill="clear" color="secondary" (click)="moreActions($event)">
                        <ion-icon slot="icon-only" name="menu-outline"></ion-icon>
                    </ion-button>
                </div>

                <ion-item class="program-mobile-image" lines="none" color="--ion-color-light-teal-2">
                    <ion-thumbnail slot="start" tappable (click)="openPreview(status?.application?.program?.image, 0)" class="mobile-thumbnail-images">
                        <img [src]="status?.application?.program?.image | img : status?.application?.program?.state : 'md'" />
                    </ion-thumbnail>
                    <ion-label class="ion-text-wrap">
                        <ion-text class="mobile-program-name" color="dark-teal">
                            <p>{{ status?.user?.application?.program.name }}</p>
                            <!-- <p>{{status?.user?.application?.program?.specialty}} {{status?.user?.application?.program?.exposuretype}}</p> -->
                            <p style="margin-bottom: 3px">
                                <ion-icon name="pin" size="medium" slot="start" color="secondary"></ion-icon>
                                {{ status?.user?.application?.program?.city }}, {{ status?.user?.application?.program?.state }}
                            </p>
                            <p>
                                <ion-icon name="medkit" slot="start" size="medium" color="secondary"></ion-icon>
                                Clinical Experience:
                                {{ status?.user?.application?.program?.exposuretype }}
                            </p>
                        </ion-text>
                    </ion-label>
                </ion-item>

                <ion-list lines="none" class="program-info-card">
                    <ion-item color="light-teal" style="width: 90%">
                        <ion-label class="ion-text-wrap program-details-label">
                            <ion-text color="dark-teal" class="section-title">
                                {{ status?.user?.application?.program?.name }}
                            </ion-text>
                            <div class="program-title-padding">
                                <ion-text color="dark-teal">
                                    <p>
                                        <ion-icon name="pin" size="medium" slot="start" color="secondary"></ion-icon>
                                        {{ status?.user?.application?.program?.city }}, {{ status?.user?.application?.program?.state }}
                                    </p>
                                </ion-text>
                            </div>
                            <div class="program-title-padding">
                                <ion-text color="dark-teal">
                                    <p>
                                        <ion-icon name="medkit" slot="start" size="medium" color="secondary"></ion-icon>
                                        Clinical Experience:
                                        {{ status?.user?.application?.program?.exposuretype }}
                                    </p>
                                </ion-text>
                            </div>
                        </ion-label>
                    </ion-item>
                    <ion-item class="ion-text-center desktop-program-tags" color="light-teal" lines="none">
                        <div class="chips-parent">
                            <div class="chips-container" *ngFor="let tag of status?.user?.application?.program?.programtags">
                                <ion-chip [routerLink]="['/search/']" [queryParams]="{ tags: tag }" class="chip-container">{{ tag }} </ion-chip>
                            </div>
                        </div>
                    </ion-item>
                </ion-list>
            </ion-col>
        </ion-row>
        <ion-row class="mobile-program-tags">
            <ion-col size="12">
                <ion-item class="ion-text-center mobile-program-tags" color="light-teal" lines="none">
                    <div class="chips-parent">
                        <div class="chips-container" *ngFor="let tag of status?.user?.application?.program?.programtags">
                            <ion-chip [routerLink]="['/search/']" [queryParams]="{ tags: tag }" class="chip-container">{{ tag }} </ion-chip>
                        </div>
                    </div>
                </ion-item>
            </ion-col>
        </ion-row>
        <ion-row class="ion-justify-content-center" *ngIf="canBook$ | async">
            <ion-col size="10" size-xs="12" size-sm="12" size-md="10" size-lg="10" size-xl="10">
                <!-- <app-book-now [status]="status" [showDynamicCopy]="showDynamicCopy"></app-book-now> -->
                <!-- ************************************************************************* -->
                <ion-card class="non-booking-card ion-text-center">
                    <ion-card-header class="card-header-starttime">
                        <ion-card-title class="ion-text-center">
                            <div class="application-starttime bold-text">
                                {{ status?.application?.type }}<br />
                                <span class="note-text"
                                    >{{ status?.application?.startdate | date : 'longDate' : 'UTC' }}
                                    -
                                    {{ status?.application?.enddate | date : 'longDate' : 'UTC' }}</span
                                >
                            </div>
                        </ion-card-title>
                    </ion-card-header>
                    <ion-card-content
                        *ngIf="!status.application?.madedeposit && !status.application?.madepayment && !status.application?.madefullpayment"
                        class="card-content"
                    >
                        <ion-item lines="none">
                            <ion-label class="ion-text-wrap">
                                <div *ngIf="!isPreapprovalProgram" class="text-teal">
                                    Before you can hold your seat and complete the rest of your application,
                                    <span class="bold-text highlight">you must reserve your rotation</span>
                                    by making a payment.
                                </div>
                                <div *ngIf="isPreapprovalProgram" class="status-update-text">
                                    Please upload the pre-approval requirements below and submit a pre-payment of the program deposit amount. Upon Payment, a
                                    hold will be placed on the program seat for you. If you have further questions about next steps, please contact
                                    <a class="advisors-link" href="mailto:advisors@amopportunities.org">advisors&#64;amopportunities.org</a>
                                </div>
                            </ion-label>
                        </ion-item>
                        <div>
                            <p class="ion-text-center" *ngIf="application?.pendingWiretransfer">Pending Wire Transfer</p>
                            <p class="ion-text-center refund-note" *ngIf="isPreapprovalProgram">
                                If not approved for any reason, your pre-payment is fully refundable
                            </p>
                            <ion-button
                                type="button"
                                [queryParams]="{
                                    applicationid: status?.application?.id,
                                    type: 'booking'
                                }"
                                [routerLink]="['/payment/']"
                                routerDirection="'root'"
                            >
                                {{ isPreapprovalProgram ? 'Make your Pre-Payment' : 'Pay and Reserve' }}
                            </ion-button>
                            <p *ngIf="isPreapprovalProgram" class="sub-text">
                                *Note that making a payment does not reserve your seat until your program has confirmed
                            </p>
                            <br />
                            <div *ngIf="hideButton | async">
                                <div class="function-title orange">
                                    <fa-icon [icon]="icons?.arrow" class="orange"></fa-icon>
                                    Complete your payment process below.
                                    <fa-icon [icon]="icons?.arrow" class="orange"></fa-icon>
                                </div>
                                <br />
                                <p class="cancel-text">Not ready to pay yet?</p>
                                <ion-button fill="clear" type="button" (click)="cancelPayment()" color="primary" class="cancel-link">Go back</ion-button>
                            </div>
                        </div>
                    </ion-card-content>
                    <ion-card-content
                        *ngIf="
                            status.application.states === 'Pending-Booked' ||
                            status.application?.madedeposit ||
                            status.application?.madepayment ||
                            status.application?.madefullpayment
                        "
                        class="card-content"
                    >
                        <ion-item lines="none">
                            <ion-label class="ion-text-wrap">
                                <div class="note-text status-update-text">
                                    Before you can hold your seat and complete the rest of your application, please upload your eligibility documents for
                                    pre-approval.
                                </div>
                            </ion-label>
                        </ion-item>
                        <div>
                            <p class="ion-text-center sub-text">* We usually receive updates within 3-5 buinsess days after submitting your request</p>
                        </div>
                    </ion-card-content>
                </ion-card>

                <!-- ***************************************************************************** -->
            </ion-col>
        </ion-row>
        <ion-row class="ion-justify-content-center" *ngIf="!(canBook$ | async)">
            <ion-col size="10">
                <app-booking-block [status]="status"></app-booking-block>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-card>
<div>
    <ion-toolbar>
        <ion-segment (ionChange)="segmentChanged($event)" mode="md" [value]="pending?.view">
            <ion-segment-button *ngIf="showPreApprovalDocument" value="document" checked mode="md">
                <ion-label class="segment-label">
                    {{ (toolService.content | async)?.application?.components?.reserved?.segmentbuttons?.application }}</ion-label
                >
            </ion-segment-button>
            <ion-segment-button value="program" mode="md">
                <ion-label class="segment-label"> {{ (toolService.content | async)?.application?.components?.reserved?.segmentbuttons?.program }}</ion-label>
            </ion-segment-button>
        </ion-segment>
    </ion-toolbar>

    <div [ngSwitch]="pending?.view">
        <div *ngSwitchCase="'document'">
            <app-eligibility-documents [status]="status" *ngIf="showPreApprovalDocument"> </app-eligibility-documents>
        </div>
        <div *ngSwitchCase="'program'">
            <app-program-summary [program]="status?.application?.program" [application]="status?.application"> </app-program-summary>
        </div>
    </div>
</div>
